import BaseShopLayout from "@shop/components/BaseShopLayout";
import { Stack, Typography } from "@mui/material";
import PackageSelection from "@shop/components/PackageSelection";
import AIServiceSelection from "@shop/components/AIServiceSelection";
import { useCheckoutPersistence } from "../hooks/useCheckoutPersistence";
import CheckoutResumePrompt from "@shop/components/CheckoutResumePrompt";

const OnboardingShopPage = () => {
    // Aktiviere automatische Checkout-Persistierung
    const { hasRestoredState, isRestoring } = useCheckoutPersistence();
    return (
        <BaseShopLayout title={"Shop"} description={"Hier kannst Du Dich für eine Auswahl unserer Produkte entscheiden."}>
            <Stack spacing={4.5}>
                {/* Zeige Benachrichtigung wenn Checkout-Zustand wiederhergestellt wurde */}
                <CheckoutResumePrompt hasRestoredState={hasRestoredState} />
                <Stack spacing={2}>
                    <Typography variant={"h4"} align={"center"}>
                        ESGbot Jahreslizenz
                    </Typography>

                    <PackageSelection />
                </Stack>

                <Stack spacing={2}>
                    <Typography variant={"h4"} align={"center"}>
                        KI-Services
                    </Typography>

                    <AIServiceSelection />
                </Stack>
            </Stack>
        </BaseShopLayout>
    );
};

export default OnboardingShopPage;
